import { clsx, type ClassValue } from 'clsx';

/**
 * Joins class names (shadcn/ui's `cn`). Without tailwind-merge, to keep the bundle
 * small: components put overridable utilities last and callers avoid conflicting ones.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}

/** "Acme Fitness" -> "AF" */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const letters = words.length > 1 ? [words[0]![0], words[words.length - 1]![0]] : [name.trim()[0], name.trim()[1]];
  return letters.filter(Boolean).join('').toUpperCase() || '?';
}
